import { CSSProperties } from "react"

export interface IAgTechAppLoading {
    showSurface: (props: {
        children: JSX.Element,
        classes?: string,
        styles?: CSSProperties
    }) => JSX.Element,
    showLoader: (loadingText: string) => React.ReactNode,
    showLoadingError: (props: {
        errorMessage: string,
        error?: any,
        retryConfiguration?: AgTechAppLoadingRetryConfiguration
    }) => React.ReactNode,
    actions: IAgTechAppActionSurfaceConfiguration
}

export interface IAgTechAppActionSurfaceConfiguration {
    renderSurface: (props: { children: JSX.Element }) => React.ReactNode,
    renderSurfaceBody: (props: { isOpen: boolean, children: JSX.Element }) => React.ReactNode,
    renderActionSubmission: (props: { submissionMessage: string, loaderSize?: number }) => React.ReactNode,
    renderActionConfirmation: (props: { confirmationMessage: string, confirmationDetails?: string }) => React.ReactNode,
}

export type AgTechAppLoadingRetryConfiguration = {
    retryButtonText: string,
    retryIconText: string,
    retryAction: () => Promise<any>
}

export const DefaultAgTechAppLoading: IAgTechAppLoading = {
    showSurface: (props) => {
        console.error('Surface shown by default handler');
        return <>{props.children}</>;
    },
    showLoader: loadingText => {
        console.error('Loader shown by default handler: ' + loadingText);
        return null;
    },
    showLoadingError: loadingError => {
        console.error('Loading error shown by default handler: ' + loadingError);
        return null;
    },
    actions: {
        renderSurface: (props: { children: JSX.Element }) => {
            console.error('Action surface rendered by default handler');
            return null;
        },
        renderSurfaceBody: (props: { children: JSX.Element }) => {
            console.error('Action surface rendered by default handler');
            return null;
        },
        renderActionSubmission: submissionText => {
            console.error('Submissions shown by default handler: ' + submissionText);
            return null;
        },
        renderActionConfirmation: (props: { confirmationMessage: string, confirmationDetails?: string }) => {
            console.error('Submission confirmation shown by default handler');
            return null;
        },

    }
}